import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel, paymentHelper } from 'helpers';
import { PaymentActionTypes, PaymentActions } from 'store/payment';
import { ErrorAction } from '@sofology/sofologycomponents';
import { CardSuccessfulPaymentResponseModel } from 'models/Payment';

export interface CardPaymentCompleteAction extends Action<PaymentActionTypes.CARD_PAYMENT_COMPLETE> {
    vendorTxCode: string;
}

export interface CardPaymentCompleteActionStart extends Action<PaymentActionTypes.CARD_PAYMENT_COMPLETE_START> {
}

export interface CardPaymentCompleteActionSuccess extends Action<PaymentActionTypes.CARD_PAYMENT_COMPLETE_SUCCESS> {
    cardPaymentSuccessfulResult: CardSuccessfulPaymentResponseModel;
}

export interface CardPaymentCompleteActionError extends ErrorAction<PaymentActionTypes.CARD_PAYMENT_COMPLETE_ERROR> {

}

export const cardPaymentComplete: (vendorTxCode: string) => CardPaymentCompleteAction = (vendorTxCode: string) => ({
    type: PaymentActionTypes.CARD_PAYMENT_COMPLETE,
    vendorTxCode
});
cardPaymentComplete[ACTION_CREATOR_NAME] = 'cardPaymentComplete';

export type CardPaymentCompleteFunc = (...args: Parameters<typeof cardPaymentComplete>) => void;

export function* cardPaymentCompleteSaga({ vendorTxCode }: CardPaymentCompleteAction) {
    yield put<PaymentActions>({
        type: PaymentActionTypes.CARD_PAYMENT_COMPLETE_START
    });

    try {
        const cardPaymentSuccessfulResult = new CardSuccessfulPaymentResponseModel();
        cardPaymentSuccessfulResult.vendorTxCode = vendorTxCode;

        paymentHelper.saveSuccessfulPaymentResult(cardPaymentSuccessfulResult);

        yield put<PaymentActions>({
            type: PaymentActionTypes.CARD_PAYMENT_COMPLETE_SUCCESS,
            cardPaymentSuccessfulResult
        });

        return true;
    } catch (error) {
        yield put<PaymentActions>({
            type: PaymentActionTypes.CARD_PAYMENT_COMPLETE_ERROR,
            error: errorToBasketErrorModel(error, 'cardPaymentCompleteSaga')
        });

        return false;
    }
}